export default class State extends Backbone.Model {
  get defaults () {
    return {
      page: 'show'
    }
  }

  inspect () {
    return super.toJSON()
  }
}
